import * as React from 'react';
import {Divider, Input, Menu, Typography} from 'antd';
import useAuth from '../../utils/AuthContext';
import Flex from '../Flex';
import {useHistory} from 'react-router-dom';

const {Text} = Typography;

function PageHeader() {
  const auth = useAuth();
  const history = useHistory();

  return (
    <React.Fragment>
      <div className="pageHeader">
        <div className="titleWrapper">
          <Flex className={'titleContainer'}>
            <div style={{cursor: 'pointer'}} onClick={() => history.push('/')}>
              <h1>学位答辩申请系统</h1>
              <small>前往首页</small>
            </div>
            <div className={'titleFloat'}>SJTU</div>
            <div style={{paddingRight: 20, zIndex: 20, display: 'flex', alignItems: 'flex-end', flexDirection: 'column', justifyContent: 'flex-end'}}>
              {auth.currentUser ? (
                <div>
                  {/*{auth.currentUser.type == UserType.管理员 && (*/}
                  {/*  <React.Fragment>*/}
                  {/*    <a onClick={QuickRouter.manageContestList}>活动管理</a>*/}
                  {/*    <Divider type={'vertical'} />*/}
                  {/*    <a onClick={QuickRouter.manageKnowledgeBankList}>题目数据库</a>*/}
                  {/*    <Divider type={'vertical'} />*/}
                  {/*  </React.Fragment>*/}
                  {/*)}*/}
                  <Text strong>当前登录: {auth.currentUser.name}</Text>
                  <Divider type={'vertical'} />
                  <a onClick={auth.logout}>注销</a>
                </div>
              ) : (
                <div>
                  <a>登录</a>
                </div>
              )}
            </div>
          </Flex>
        </div>
      </div>
    </React.Fragment>
  );
}
export default PageHeader;
